var GenericDictionary = /** @class */ (function () {
    function GenericDictionary() {
        this.dictionary = new Map();
    }
    /**
     * Register an element
     * @param {string} name
     * @param {T} item
     */
    GenericDictionary.prototype.register = function (name, item) {
        this.dictionary.set(name, item);
        return true;
    };
    /**
     * Check if dictionary has an element of the specified name
     *
     * @param {string} name
     * @returns true if an element does exist and false otherwise
     */
    GenericDictionary.prototype.has = function (name) {
        return this.dictionary.has(name);
    };
    /**
     * Get the declared item of a field
     *
     * @param type
     * @param field
     *
     * @returns The field item
     */
    GenericDictionary.prototype.get = function (name) {
        if (!this.has(name)) {
            return undefined;
        }
        return this.dictionary.get(name);
    };
    /**
     * Liste des clés du dictionnaire
     */
    GenericDictionary.prototype.keys = function () {
        return Array.from(this.dictionary.keys());
    };
    /**
     * Liste des clés du dictionnaire
     */
    GenericDictionary.prototype.values = function () {
        return Array.from(this.dictionary.values());
    };
    GenericDictionary.prototype.entries = function () {
        return Array.from(this.dictionary.entries());
    };
    return GenericDictionary;
}());
export default GenericDictionary;
